import React, { FC } from 'react'
import SocialLinks from '@designSystem/LoggedOutWrap/SocialLinks'
import { LoggedOutWrapper } from '@designSystem/LoggedOutWrap/styles'

type Props = {
  children: React.ReactNode
}

export const LoggedOutWrap: FC<Props> = ({ children }) => {
  return (
    <LoggedOutWrapper>
      {children}
      <SocialLinks />
    </LoggedOutWrapper>
  )
}
